import { RootState, useSelector } from '../../redux/store';
import { Autocomplete, TextField } from '@mui/material';
import { DEVICE_TAG_LABEL, DeviceTag } from '../../@types/model/user';
import { useTranslation } from 'react-i18next';

interface LabelPickerProps {
  selection: string | undefined;
  changeHandler: (guid: string | undefined) => void;
}

const LabelPicker = (props: LabelPickerProps) => {
  const { t } = useTranslation();
  const { loaded, deviceTags } = useSelector((state: RootState) => state.user);
  if (!loaded) {
    return null;
  }
  const tags = deviceTags.filter((dt: DeviceTag) => dt.attributes.type === DEVICE_TAG_LABEL);
  return (
    <Autocomplete
      disablePortal
      sx={{ minWidth: '200px' }}
      autoHighlight
      value={
        props.selection && tags ? tags.find((dt: DeviceTag) => dt.guid === props.selection) : null
      }
      options={tags}
      onChange={(event, values) => props.changeHandler(values ? values.guid : undefined)}
      getOptionLabel={(option) => {
        return option.attributes.name;
      }}
      renderOption={(props, option) => (
        <li key={option.guid} {...props}>
          {option.attributes.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('tags')}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password'
          }}
        />
      )}
    />
  );
};

export default LabelPicker;
